import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { TellentAssistantBrandMarkComponent } from '../brand-mark/tellent-assistant-brand-mark.component';

@Component({
  selector: 'tellent-assistant-thinking-indicator',
  imports: [TellentAssistantBrandMarkComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<tellent-assistant-brand-mark class="brand" [size]="18" />
    <span class="label">{{ 'tlc.tellent_assistant.tool_call.thinking_status' | translate }}</span>`,
  styleUrl: './tellent-assistant-thinking-indicator.component.less',
})
export class TellentAssistantThinkingIndicatorComponent {}
